<div [ngSwitch]="!!state.value" (click)="toggle()" tabindex="0" class="twiddle">
    <div style="display: flex; align-items: center" [class.section-header]="isSectionHeader" [class.rem-header-margin]="isSectionHeader">
        <i *ngIf="icon" style="font-size: large; margin-right: 0.5em" [ngClass]="'fas ' + icon" aria-hidden="true"></i>
        <tra [slug]="caption"></tra>
    </div>
    <span>
        <i *ngSwitchCase="false" class="icon fas fa-angle-right"></i>
        <i *ngSwitchCase="true" class="icon fas fa-angle-down"></i>
    </span>
</div>